import { graphql } from '../../generated';

export const GET_SERVER_STATUS = graphql(`
  query ServerStatusQuery {
    serverConfiguration {
      activeScalingConfiguration
      scalingSchedules {
        id
        configuration
        on
      }
    }
  }
`);

export const CREATE_SCHEDULE = graphql(`
  mutation CreateSchedule($configuration: ScalingConfigurationName!, $on: ISO8601DateTime) {
    createServersScalingSchedule(input: { configuration: $configuration, on: $on }) {
      scalingSchedule {
        id
        configuration
        on
      }
    }
  }
`);

export const DELETE_SCHEDULE = graphql(`
  mutation DeleteSchedule($id: ID!) {
    deleteServersScalingSchedule(input: { id: $id }) {
      clientMutationId
    }
  }
`);

export const ORDERS_PER_MINUTE = graphql(`
  query OrdersPerMinute {
    orderStatistics {
      ordersPerMinute {
        datetime
        value
      }
      paymentsPerMinute {
        datetime
        value
      }
    }
  }
`);

export const ORDERS_CREATED_PER_MINUTE = graphql(`
  query OrdersCreatedPerMinute($during: TimeRangeInput) {
    orderStatistics(during: $during) {
      ordersCreatedPerMinute {
        datetime
        value
      }
    }
  }
`);

export const TOP_IPS = graphql(`
  query TopIps($during: TimeRangeInput) {
    orderStatistics(during: $during) {
      topIps {
        ip
        count
      }
    }
  }
`);

export const TOP_PAYMENT_FINGERPRINTS = graphql(`
  query TopPaymentFingerprints($during: TimeRangeInput) {
    orderStatistics(during: $during) {
      topPaymentFingerprints {
        paymentMethodId
        fingerprint
        count
      }
    }
  }
`);
